import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-medication-prescription',
  templateUrl: './medication-prescription.component.html',
  styleUrl: './medication-prescription.component.scss'
})
export class MedicationPrescriptionComponent implements OnInit {
  @Input() petDataIsValid: Subject<boolean>;

  isPetDataValid = false;
  screenWidth: number;
  mobileScreen: boolean;

  constructor() {
    this.getScreenSize();
  }

  ngOnInit(): void {
    this.petDataIsValid.subscribe((isValid: boolean) => {
      this.isPetDataValid = isValid;
    });
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    this.mobileScreen = this.screenWidth <= 768;
  }
}
